import { useCallStore } from "~/stores/useCallStore";
import { useLiveStore } from "~/stores/useLiveStore";

/**
 * 通話中（発信中・着信中・通話接続中）または配信視聴中かどうかを返す。
 * ポーリング停止・Toast表示抑制の判定に使用する。
 */
export const useIsOnCall = (): boolean => {
  const callPhase = useCallStore((s) => s.phase);
  const livePhase = useLiveStore((s) => s.phase);

  const callActive =
    callPhase.type === "outgoingConnecting" ||
    callPhase.type === "incomingRinging" ||
    callPhase.type === "inCall";

  const liveActive = livePhase === "connecting" || livePhase === "connected";

  return callActive || liveActive;
};
